<template>
  <div class="form-group row">
    <label class="col-4 col-form-label text-right">
      <em v-if="required" style="color: red;">*</em>
      {{ label }}
    </label>
    <div class="col-6 input-group">
      <div v-if="!!prefix" class="input-group-addon">{{ prefix }}</div>
      <!--
      <input class="form-control" :class="{ 'is-valid': !hasError, 'is-invalid': hasError }" type="password" v-model="input" @keyup="change()" @change="change()" v-validate.initial="validate" :name="label" :disabled="disabled">
      -->
      <input class="form-control" type="password" v-model="input" @keyup="change()" @change="change()" :name="label" :disabled="disabled">
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        input: ''
      }
    },
    props: {
      label: {
        required: false,
        default: '',
        type: String
      },
      value: [ String, Number ],
      validate: {
        required: false,
        type: [ Object, String ],
        default: 'required'
      },
      prefix: {
        required: false,
        type: String,
        default: null
      },
      required: {
        required: false,
        type: Boolean,
        default: true
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false
      }
    },
    methods: {
      change () {
        this.$emit('input', this.input)
      }
    },
    watch: {
      value (value) {
        this.input = value
      }
    },
    created () {
      this.input = this.value
    },
    computed: {
      hasError () {
        return this.errors.has(this.label)
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/utils/password-field.vue